module.exports = __webpack_public_path__ + "static/media/a6.01eb0cfe.pdf";